import './version-button.scss';
import React, { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'src/components/store';
import { PolicyActionDto, PolicyActionModal } from './policy-action-modal';
import { VersionButton } from './version-button';
import { RestorePolicy } from '../restore-policy-modal/restore-policy';
import moment from 'moment/moment';

interface VersionButtonProps {
    isShowPartialLabels?: boolean;
}

export const VersionButtonContainer: React.FC<VersionButtonProps> = observer(({ isShowPartialLabels }) => {
    const [isApplyPolicyPopupVisible, setIsApplyPolicyPopupVisible] = useState(false);
    const [showRestorePolicyModal, setShowRestorePolicyModal] = useState(false);

    const { fwVersionStore, customerStore } = useStores();
    const { sidMetadata } = customerStore;

    const applyPolicy = (data: PolicyActionDto) => {
        setIsApplyPolicyPopupVisible(false);
        void fwVersionStore.commitAndPushVersion(data);
    };

    const version = useMemo(() => isShowPartialLabels ? fwVersionStore.latestVersion : fwVersionStore.selectedFwVersion,
        [isShowPartialLabels ? fwVersionStore.latestVersion : fwVersionStore.selectedFwVersion]);

    const scheduleDate = useMemo(() => sidMetadata?.scheduledDate ?
        new Date(moment(sidMetadata?.scheduledDate).format()) :
        undefined, [sidMetadata?.scheduledDate]);

    return <>
        <PolicyActionModal initialData={{
            policyName: version?.versionName,
            policyComments: version?.comments,
            externalId: version?.externalId,
            selectedConnections: customerStore.isSourceScheduledVersion ? sidMetadata?.targetSids : undefined,
            scheduleDate: customerStore.isSourceScheduledVersion ? scheduleDate : undefined
        }}
                           visible={isApplyPolicyPopupVisible && customerStore.isAvailable}
                           close={() => setIsApplyPolicyPopupVisible(false)}
                           ok={applyPolicy}
                           displayExtraOptions={true}/>
        <RestorePolicy open={showRestorePolicyModal} close={() => setShowRestorePolicyModal(false)} />
        <VersionButton isShowPartialLabels={isShowPartialLabels}
            version={version}
            onApplyPolicy={() => setIsApplyPolicyPopupVisible(true)}
            onRestorePolicy={() => setShowRestorePolicyModal(true)}
            scheduleDate={scheduleDate}/>
    </>;
});